// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".info-box-list li[data-v-459ba820]{font-size:14px;margin-top:4px;margin-bottom:4px}", "",{"version":3,"sources":["/app/app/javascript/dashboard/components/ui/Wizard.vue"],"names":[],"mappings":"AACA,mCACE,cAAA,CACA,cAAA,CACA,iBAAA","file":"Wizard.vue","sourcesContent":["\n.info-box-list li {\n  font-size: 14px;\n  margin-top: 4px;\n  margin-bottom: 4px;\n}\n"]}]);
// Exports
module.exports = exports;
